.screen {
  padding: 36px 72px;
  display: flex;
  flex-direction: column;
}
.header {
  margin-bottom: 24px;
}
.grid {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 20px;
  align-content: start;
  overflow: auto;
  /* Bottom padding keeps the last row clear of the floating action bar. */
  padding: 8px 8px 130px;
}
.bed {
  height: 104px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background: var(--color-surface);
  border: 2px solid var(--color-divider);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  transition:
    box-shadow 0.15s,
    border-color 0.15s;
}
.bed:hover {
  box-shadow: var(--shadow-md);
}
.bed[aria-pressed='true'] {
  border-color: var(--color-accent);
  background: var(--color-accent-100);
}
.number {
  font-family: var(--font-heading);
  font-weight: 800;
  font-size: 32px;
  color: var(--color-text);
  line-height: 1;
}
.tag {
  font-size: 11px;
  font-weight: 700;
  color: var(--color-neutral-500);
}
.bed[aria-pressed='true'] .tag {
  color: var(--color-accent-700);
}
.sanitised .tag,
.bed.sanitised[aria-pressed='true'] .tag {
  color: var(--color-success);
}
